import { Location } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { ToastService } from '@teorema/patron';
import { Ticket } from 'src/app/models';
import { TcDataService, TcTicketService } from 'src/app/shared/services';
import { AbstractTicketComponent } from '../../ticket/abstract-ticket/abstract-ticket.component';
import { TicketShowBodyComponent } from '../../ticket/ticket-show/ticket-show-body/ticket-show-body.component';

@Component({
  selector: 'app-ticket-modal',
  templateUrl: './ticket-modal.component.html',
  styleUrls: ['./ticket-modal.component.scss'],
  standalone: false,
})
export class TicketModalComponent extends AbstractTicketComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() override entity: Ticket | undefined;
  @Input() taskId;
  @Input() userLogged;

  @Output() closed = new EventEmitter<any>();

  loading = false;
  showTabsBodies: boolean = false;

  @ViewChild('ticketModalBody') ticketModalBody?: ElementRef;

  private _ticketShowBodyComponent?: TicketShowBodyComponent;

  @ViewChild(TicketShowBodyComponent)
  set ticketShowBodyComponent(value: TicketShowBodyComponent | undefined) {
    this._ticketShowBodyComponent = value;
    if (this._ticketShowBodyComponent && this.entity && !this.loading) {
      this._ticketShowBodyComponent.assembleTicket(this.entity);
      this._ticketShowBodyComponent.setUserValues();
    }
  }

  get ticketShowBodyComponent(): TicketShowBodyComponent | undefined {
    return this._ticketShowBodyComponent;
  }

  constructor(
    protected authService: AuthService,
    protected override dataService: TcDataService,
    protected override _location: Location,
    protected override router: Router,
    protected ticketService: TcTicketService,
    protected toastService: ToastService,
    private zone: NgZone
  ) {
    super(dataService, _location, router);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.ticketService.getFiltersFromLocalStorage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['entity']?.currentValue &&
      (!changes['entity']?.previousValue ||
        changes['entity']?.currentValue?.id !== changes['entity']?.previousValue?.id)
    ) {
      this.ticketShowBodyComponent?.reset();
      this.loadTicket();

      if (!this.showTabsBodies) {
        setTimeout(() => {
          //Sem isso ele tem um delay pra mostrar o modal quando abre a primeira vez
          this.showTabsBodies = true;
        }, 1);
      }
    }
  }

  async loadTicket() {
    this.loading = true;
    let response = await this.ticketService.findById(this.entity!!.id).catch(e => {
      console.error(e);
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });
    if (response?.id) {
      this.assembleTicket(response);

      //   setTimeout(() => {
      //     // this.ticketModalBody.nativeElement.scrollTop = 45;
      //   }, 1);
    } else {
      this.loading = false;
    }
  }

  assembleTicket(response: Ticket) {
    this.entity = response;
    if (this.entity.details) {
      var detailsArray = this.entity.details;
      detailsArray.sort((a, b) => (a.created_at! < b.created_at! ? 1 : -1));

      detailsArray = detailsArray.filter(det => {
        return det.observation && det.observation.length;
      });

      this.entity.details = detailsArray;
    }
    // this.zone.run(() => {
    this.ticketShowBodyComponent?.assembleTicket(this.entity!);
    this.loading = false;
    this.ticketShowBodyComponent?.setUserValues();
    // });
  }

  openInNewTab() {
    if (this.entity?.id) {
      window.open(window.location.origin + '/chamados/editar/' + this.entity.id, '_blank');
    }
  }

  // Oi, eu estou aqui para sobrescrever o método listenForTicketUpdates de AbstractTicketComponent,
  // pois o modal não deve ouvir o canal de atualização pois quem faz a atualização do modal é a própria tela de sprint
  // Não rele a mão
  protected listenForTicketUpdates() {}

  close() {
    this.visible = false;

    setTimeout(() => {
      //Sem isso tem um delay pro modal desaparecer
      this.closed.emit({
        saved: this.saved,
        entity: this.entity,
      });
    }, 1);
  }
}
